import React, { useEffect } from 'react'
import { Col, Form, Dropdown, Row } from 'react-bootstrap'
import { KYC_CARD_TYPE, KYC_THAILAND_STAY_OPTIONS } from '../../constants'
import { KYC_STAY } from '../../constants'
import Colors from '../../../../constants/Colors'
import { fullMonthTH } from '../../../../constants/constants'
import { useCallback } from 'react'
import { KYC_CUSTOMER_CITIZENSHIP } from '../../constants'
import { PATTERNS } from '../../utils'
import { getDays, getYears } from '../../utils'

const KYCForeignerForm = ({ nation, cardInfo, setUserKYCData, stayType, setStayType }) => {
  const years = getYears()

  const handleChangeCardIdChange = useCallback(
    (event) => {
      const value = event.target.value
      if (value === '') {
        setUserKYCData((prev) => ({
          ...prev,
          cardInfo: { ...prev.cardInfo, cardId: '' },
        }))
        return
      }
      const cardId =
        cardInfo.cardType === KYC_CARD_TYPE.PASSPORT
          ? PATTERNS.ENGLISH_WITH_NUMBER.test(value)
          : PATTERNS.NUMBER.test(value)

      if (!cardId) {
        return
      }

      setUserKYCData((prev) => ({
        ...prev,
        cardInfo: { ...prev.cardInfo, cardId: event.target.value },
      }))
    },
    [cardInfo.cardType, setUserKYCData],
  )

  useEffect(() => {
    if (nation === KYC_CUSTOMER_CITIZENSHIP.THAI) {
      return
    }

    setUserKYCData((prev) => ({
      ...prev,
      cardInfo: { ...prev.cardInfo, cardType: KYC_CARD_TYPE.PASSPORT },
    }))
  }, [setUserKYCData, nation])

  if (nation === KYC_CUSTOMER_CITIZENSHIP.THAI) {
    return null
  }

  return (
    <div className="mt-4">
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          ชื่อ :
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            onChange={(event) =>
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, firstName: event.target.value },
              }))
            }
            value={cardInfo.firstName}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          นามสกุล :
        </Form.Label>
        <Col sm="9">
          <Form.Control
            type="text"
            value={cardInfo.lastName}
            onChange={(event) =>
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, lastName: event.target.value },
              }))
            }
          />
        </Col>
      </Form.Group>

      {/* Passport */}
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          <Form.Check
            value={KYC_CARD_TYPE.PASSPORT}
            label="Passport"
            type="radio"
            onChange={() => {
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, cardType: KYC_CARD_TYPE.PASSPORT, cardId: '' },
              }))
            }}
            checked={cardInfo.cardType === KYC_CARD_TYPE.PASSPORT}
            required
          />
        </Form.Label>

        <Col sm="9">
          <Form.Control
            disabled={cardInfo.cardType !== KYC_CARD_TYPE.PASSPORT}
            style={{
              backgroundColor: cardInfo.cardType !== KYC_CARD_TYPE.PASSPORT ? Colors.LIGHT_GREY2 : 'white',
            }}
            value={cardInfo.cardType === KYC_CARD_TYPE.PASSPORT ? cardInfo.cardId : ''}
            onChange={handleChangeCardIdChange}
          />
        </Col>
      </Form.Group>

      {/* Work Permit */}
      <Form.Group as={Row}>
        <Form.Label column sm="3">
          <Form.Check
            value={KYC_CARD_TYPE.WORK_PERMIT}
            label="Work permit"
            type="radio"
            onChange={() => {
              setUserKYCData((prev) => ({
                ...prev,
                cardInfo: { ...prev.cardInfo, cardType: KYC_CARD_TYPE.WORK_PERMIT, cardId: '' },
              }))
            }}
            checked={cardInfo.cardType === KYC_CARD_TYPE.WORK_PERMIT}
            required
          />
        </Form.Label>

        <Col sm="9">
          <Form.Control
            disabled={cardInfo.cardType !== KYC_CARD_TYPE.WORK_PERMIT}
            style={{
              backgroundColor: cardInfo.cardType !== KYC_CARD_TYPE.WORK_PERMIT ? Colors.LIGHT_GREY2 : 'white',
            }}
            maxLength={13}
            value={cardInfo.cardType === KYC_CARD_TYPE.WORK_PERMIT ? cardInfo.cardId : ''}
            onChange={handleChangeCardIdChange}
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row} className="pt-1">
        <Form.Label column sm="3">
          จุดประสงค์ :
        </Form.Label>
        <Col sm="9">
          {KYC_THAILAND_STAY_OPTIONS.map((item) => {
            return (
              <Form.Check
                key={item.value}
                value={item.value}
                label={item.label}
                type="radio"
                onChange={() => {
                  setStayType(item.value)
                  setUserKYCData((prev) => ({
                    ...prev,
                    cardInfo: { ...prev.cardInfo, foreignerStatus: item.value },
                  }))
                }}
                checked={stayType === item.value}
              />
            )
          })}
          {stayType === KYC_STAY.CUSTOM && (
            <Form.Control
              as="textarea"
              rows={2}
              value={cardInfo.description}
              placeholder="กรุณากรอกข้อมูล"
              className="mt-1"
              onChange={(e) => {
                setUserKYCData((prev) => ({
                  ...prev,
                  cardInfo: { ...prev.cardInfo, customForeignerStatus: e.target.value },
                }))
              }}
              maxLength={220}
            />
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} className=" pt-1 align-items-center">
        <Form.Label column sm="3">
          วันเกิด (ค.ศ.)
        </Form.Label>
        <Col sm={9}>
          <Row>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          year: value.target.value,
                          month: '',
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.year}
                >
                  <option value="" disabled>
                    ปี
                  </option>
                  {years.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.birthDate.year}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          ...prev.cardInfo.birthDate,
                          month: value.target.value,
                          day: '',
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.month}
                >
                  <option value="" disabled>
                    เดือน
                  </option>
                  {fullMonthTH.map((item, i) => (
                    <option value={i + 1} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
            <Col sm={4}>
              <Dropdown>
                <select
                  className="form-control"
                  style={{ color: Colors.DARK_GREY }}
                  disabled={!cardInfo.birthDate.month}
                  onChange={(value) =>
                    setUserKYCData((prev) => ({
                      ...prev,
                      cardInfo: {
                        ...prev.cardInfo,
                        birthDate: {
                          ...prev.cardInfo.birthDate,
                          day: value.target.value,
                        },
                      },
                    }))
                  }
                  value={cardInfo.birthDate.day}
                >
                  <option value="" disabled>
                    วัน
                  </option>
                  {getDays(cardInfo.birthDate.month, cardInfo.birthDate.year).map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Form.Group>
    </div>
  )
}

export default KYCForeignerForm
